document.addEventListener('click', function (event) {
	if (!event.target.matches('.alphalist__label')) return;
	event.preventDefault();


    var definitions = document.querySelectorAll('.lex__item');
    var letter = event.target.innerText;
    if( letter == '*' ) {
        definitions.forEach(function(def) {
            def.style.display = "";
        });
    }else{
        definitions.forEach(function(def) {
            def.style.display = "none";
        });
        var definitions_toshow = document.querySelectorAll('[data-letter="'+letter+'"]');
        definitions_toshow.forEach(function(def) {
            def.style.display = "";
        });
    }


}, false);